import cx from 'classnames';

import styles from './SectionButton.module.scss';

type SectionButtonProps = React.PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>>;

const SectionButton: React.FC<SectionButtonProps> = ({ children = null, className, onClick, ...props }) => (
	<button {...props} className={cx(styles.sectionButton, className)} onClick={onClick} type="button">
		{children}
	</button>
);

export default SectionButton;
